import styles from "./Maintenance.module.scss"

import { formatJstDateUntilMinute } from "@/utils/date"
import { maintenanceFrom, maintenanceTo } from "@/utils/env/maintenance"

const Maintenance = () => {
	const fromString = maintenanceFrom
		? formatJstDateUntilMinute(maintenanceFrom)
		: ""
	const toString = maintenanceTo ? formatJstDateUntilMinute(maintenanceTo) : ""
	return (
		<div className={styles.maintenance_page}>
			<h1>ただいまメンテナンス中です</h1>
			<p>ご不便おかけしております。</p>
			<p>現在、メンテナンス中です。</p>
			<p>ご理解いただきまして、ありがとうございます。</p>
			<br />
			<h2>メンテナンス日時</h2>
			<p>
				{fromString} ~{toString}
			</p>
		</div>
	)
}

export default Maintenance
